import React from 'react';
import { LinkProps } from '@mui/material';
import ZeusLink from './ZeusLink';

interface ZeusOrganizationLinkProps extends Omit<LinkProps, 'href' | 'children'> {
  organization: {
    id: number;
    name: string;
  };
}

export default function ZeusOrganizationLink({
  organization,
  ...linkProps
}: ZeusOrganizationLinkProps) {
  return (
    <ZeusLink path={`/organizations/${organization.id}`} {...linkProps}>
      {organization.name}
    </ZeusLink>
  );
}
